import React from 'react'
import { Button } from '@mui/material';

export default function TransactionProof({ currentActive, setNextStep }) {

    const steps = [
        {
            text: "Visit our ",
            urlMask: "Google Forms",
            url: "https://docs.google.com/forms/d/e/1FAIpQLSe0gALM9FQQf0iMXP4XaEwX1sVO9Rc4IF53Y5WHwA8ZL05hUQ/viewform"
        },
        {
            text: "Fill in the form with your name, email and submit the screenshot/picture of the transaction proof",
        },
    ];

    return (
        <div className="card w-100 my-3">
            <div className="card-body">
                <h3 className="card-title">
                    Submit Proof of Donation
                </h3>
                {
                    steps.map((x, i) => {
                        return (
                            <div key={i} className="d-flex flex-row">
                                <p className='donations-list'>{i + 1}</p>
                                <p className="ms-2 w-100">{x.text}
                                    <a href={x.url}>{x.urlMask}</a>.
                                </p>
                            </div>
                        );
                    })
                }
                <Button className='me-2' variant="contained" disableElevation onClick={() => setNextStep(currentActive - 1)}>Back</Button>
                <Button variant="contained" disableElevation onClick={() => setNextStep(currentActive + 1)}>Next</Button>
            </div>
        </div>
    )
}
